export default __webpack_public_path__ + "static/media/bulb_on.496936df.png";